import AlertHandler from "./AlertHandler";
import TempAlertHandler from "../../integration/AlertHandle"
import AuthHandler from "./AuthHandler";
import SuccessHandler from "./SuccessHandler";

export const HandlerList = {
  '1xx' : {
    match: {
      '1802' : SuccessHandler
    },
    default: TempAlertHandler
  },
  '2xx' : {
    match: {
      '200': AlertHandler,
    },
    default: AlertHandler
  },
  '3xx' : {
    match: {},
    default: SuccessHandler
  },
  '4xx' : {
    match: {},
    default: TempAlertHandler
  },
  '5xx' : {
    match: {
      '5201' : AuthHandler,
      '5202' : AuthHandler,
      '5203' : AuthHandler,
      '5204' : AuthHandler,
      '5205' : AuthHandler,
      '5208' : AuthHandler,
      '5209' : AuthHandler,
    },
    default: AlertHandler
  },
  default: AlertHandler
}
